module.exports = __webpack_public_path__ + "static/VS_Icons_color-03-8dd567e10fdda72a9703bcaa6aacbaf9.png";